export const CLOUDFLARE_CAPTCHA_SITE_KEY = window.configuration.cloudflareCaptchaSiteKey;
